import I18n from "../../../common/I18n";
import React, { useContext, useEffect, useMemo } from "react";
import ReactDOM from "react-dom";
import "antd/dist/antd.css";
import { Select, TreeSelect } from "antd";
import { isEmpty } from "../../../common/Common";
import { WarehouseContext } from "../../../context/WarehouseContext";
import _, { rest } from "lodash";
import { UserContext } from "../../../context/UserContext";

const { TreeNode } = TreeSelect;
const { Option, OptGroup } = Select;

const GLCodeSelect = (props) => {
  const {
    value,
    onChange,
    placeholder = "Select",
    size = "default",
    styleObj = {},
    defaultValue = "",
    invoiceType,
    isTemplateZoneBilling = false,
    currentAccessorialHasGlCode = true,
    toDisable = false,
    data = [],
    selectedValue,
    showSearch = true,
    allowClear = false,
    dropdownMatchSelectWidth = true,
    style = {},
    className = "",
    isEditing,
    ...restProps
  } = props;

  const userContextData = useContext(UserContext);
  const warehouseFilter = useContext(WarehouseContext);
  const { warehouses = [] } = warehouseFilter;

  const orgrules= _.get(userContextData, 'orgRules.org_billing_rules', {});
  const groupGlByWarehouseSetting = _.get(orgrules , "group_gl_by_warehouse") === "true";  
  
  useEffect(() => {
    if (isEmpty(value) && !isEmpty(defaultValue)) {
      onChange(defaultValue);
    }
  }, [value, defaultValue, onChange]);

  const onValueChange = (newValue) => {
    console.log("newValue", newValue);
    if(!isEmpty(newValue)){
      const tokens = _.split(newValue, '#$');
        onChange(tokens?.length ? tokens[0] : undefined)
    } else{
        onChange(undefined);
    }
  };

  // const renderDescriptions = (code) => {
  //   return props.data.filter(rec => rec.gl_code === code).map((rec, index) => 
  //     <TreeNode value={ `${rec.gl_code}#$${rec.description}` } title={ rec.description } key={ `${rec.gl_code}-${rec.description}-${index}` } />)
  // }

  const renderDescriptions = (code) => {
  return data.filter(rec => rec.gl_code === code).map((rec, index) => {
    // Create a unique key using a combination of unique properties and the index
    const uniqueKey = `${rec.gl_code}-${rec.description}-${index}-${rec.id || ''}`;
    return (
      <TreeNode
        value={`${rec.gl_code}#$${rec.description}`}
        title={rec.description}
        key={uniqueKey}
      />
    );
  });
}

  const isDisabled = (invoiceType, value, defaultValue) => {
    if (props.isEditing) {
      return (
        (invoiceType === "transportation_charges" && (!isEmpty(value) || !isEmpty(defaultValue))) ||
        (invoiceType === "fuel_surcharges" && (!isEmpty(value) || !isEmpty(defaultValue))) ||
        (invoiceType === "adjustment_charges" && (!isEmpty(value) || !isEmpty(defaultValue)))
      )
    }
    return (
      (invoiceType === "accessorial_charges" && (!isEmpty(value) || !isEmpty(defaultValue)))
    );
  };

  const glCodes = _.uniq(data.map((rec) => rec.gl_code));

  // If grouping GL codes by warehouse is enabled, we will render a grouped Select dropdown
  if (groupGlByWarehouseSetting) {

    const formatLabel = (text) => {
      return text
        .toLowerCase()
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    };

    // Group GL codes by warehouse
    const groupedOptions = useMemo(() => {
      if (!data.length || !warehouses.length) return [];

      const warehouseMap = warehouses.reduce((acc, warehouse) => {
        acc[warehouse.id || warehouse._id] = warehouse;
        return acc;
      }, {});

      const groupedByWarehouse = data.reduce((acc, glCode) => {
        const warehouseId = glCode.warehouse_id;
        if (!acc[warehouseId]) {
          acc[warehouseId] = [];
        }
        acc[warehouseId].push(glCode);
        return acc;
      }, {});

      return Object.entries(groupedByWarehouse).map(([warehouseId, glCodes]) => {
        const warehouse = warehouseMap[warehouseId];
        const warehouseName =
          warehouse?.name ||
          warehouse?.warehouse_name ||
          `${I18n.t('general.warehouse')} ${warehouseId}`;

        return {
          label: warehouseName,
          warehouseId,
          options: glCodes.map((glCode) => ({
            label: `${glCode.gl_code} (${formatLabel(glCode.gl_code_type)})`,
            value: glCode.gl_code,
            glCodeData: glCode,
          })),
        };
      });
    }, [data, warehouses]);

    const handleWarehouseBasedChange = (selectedValue) => {
      if (onChange) {
        const glCodeData =
          groupedOptions
            .flatMap((group) => group.options)
            .find((option) => option.value === selectedValue)?.glCodeData || null;

        onChange(selectedValue, glCodeData);
      }
    };

    // const filterOption = (input, option) => {
    //   if (!showSearch) return true;

    //   const searchText = input.toLowerCase();
    //   const optionLabel = (option?.children || "").toString().toLowerCase();
    //   const optionValue = (option?.value || "").toLowerCase();

    //   return optionLabel.includes(searchText) || optionValue.includes(searchText);
    // };

    return (
      <Select
        value={value}
        onChange={handleWarehouseBasedChange}
        placeholder={placeholder}
        disabled={toDisable}
        allowClear={allowClear}
        showSearch={showSearch}
        filterOption={true} // filterOption={filterOption}
        notFoundContent="No GL codes found"
        style={{ width: 120, ...style, ...styleObj }}
        className={className}
        optionFilterProp="label" // optionFilterProp="children"
        dropdownMatchSelectWidth={dropdownMatchSelectWidth}
        size={size}
        {...restProps}
      >
        {groupedOptions.map((group) => (
          <OptGroup key={group.warehouseId} label={group.label}>
            {group.options.map((option) => (
              <Option
                key={`${group.warehouseId}-${option.value}`}
                value={option.value}
                label={option.label}
              >
                {option.label}
              </Option>
            ))}
          </OptGroup>
        ))}
      </Select>
    );
  }

  return (
    <TreeSelect
      disabled={!isTemplateZoneBilling ? ((currentAccessorialHasGlCode && isDisabled(invoiceType, value, defaultValue)) || toDisable) : null}
      showSearch
      style={{ width: 120, ...styleObj }}
      value={value}
      dropdownStyle={{ maxHeight: 300, overflow: "auto", maxWidth: 300 }}
      placeholder={placeholder}
      // allowClear
      treeDefaultExpandAll
      onChange={onValueChange}
      size={size}
      className={className}
      {...restProps}
    >
    {
        glCodes.map(code => <TreeNode value={code} title={code} key={code}>
            {renderDescriptions(code)}
        </TreeNode>)
    }
    </TreeSelect>
  );
};

export default GLCodeSelect;
